export const included = [
  'Approximately two-hour holistic health consultation and Bio-Scan assessment',
  'Comprehensive 80+ page Bio-Scan report',
  'Personal review and integration of your consultation and scan findings',
  'Comprehensive Integrated Health Report',
  'Individualised nutritional and lifestyle recommendations',
  'Herbal recommendations where appropriate',
  'Follow-up Zoom session to take you through your Integrated Health Report',
]
